/**
 * Up to two uppercase initials from a person's name, for avatar fallbacks.
 *
 * Returns '?' rather than an empty string for a missing name: an avatar tile
 * with nothing in it reads as a broken image, whereas '?' reads as "we don't
 * know who this is", which is the truth.
 *
 * `.filter(Boolean)` drops the empty strings that repeated spaces produce, so
 * "Omar  Abdelhamid" yields OA rather than O.
 */
export default function initials(name) {
  return (name || '?')
    .split(' ')
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
